import { WorkspaceTrainingJobFragment } from './__generated__/fragments.generated';

function getInstanceTypeName(instanceType: WorkspaceTrainingJobFragment['instanceType']) {
  if (instanceType.gpuType) {
    return `${instanceType.gpuType}:${instanceType.gpuCount}`;
  }

  return instanceType.name;
}

export { getInstanceTypeName };
